<template>
  <div class="step-two px-[20px]">
    <div class="form-wrapper grid grid-cols-4-default gap-5 mb-5">
      <!-- Gender -->
      <div class="col-span-4 lg:col-span-4" v-show="!companyActive">
        <Select
          :key="translations.text.gender"
          v-model="data.gender"
          name="gender"
          rules="required"
          :placeholder="translations.text.gender"
          :options="translations.genders"
          option-label="label"
          :label="translations.text.gender"
        />
        <!-- <label class="font-body text-base text-gray-900  " for="gender">{{ translations.text.gender }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <span class="select is-fullwidth">
            <select
              v-validate="'required'"
              :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('gender') }"
              :data-vv-as="translations.text.gender"
              name="gender"
              v-model="data.gender"
              class="text-base text-gray-900 font-semibold rtl:bg-left"
            >
              <option value="" selected hidden>{{ translations.text.gender }}</option>
              <option v-for="(item, index) in translations.genders" :value="index" :key="index">{{ item }}</option>
              <option value="none" key="n/a">{{ $t('gender_other') }}</option>
            </select>
          </span>
          <span v-show="errors.has('gender')" class="font-body text-xs text-orange font-semibold">{{ errors.first('gender') }}</span>
        </div> -->
      </div>
      <!-- Date of Birth -->
      <div class="col-span-4 lg:col-span-4 grid grid-cols-6-default gap-5" v-show="!companyActive">
        <!-- Year of Birth -->
        <div class="col-span-2 md:col-span-2">
          <!-- <label class="label is-small" for="dob_year">{{ translations.text.year }}<span class="text-orange ml-1">*</span></label>
          <div class="my-2">
            <span class="select is-fullwidth">
              <select
                v-validate="{ required: true, 'is-over-18': data.dateofbirth.day + '-' + data.dateofbirth.month + '-' + data.dateofbirth.year }"
                :class="{
                  'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('dob_year'),
                }"
                :data-vv-as="translations.text.year"
                name="dob_year"
                v-model="data.dateofbirth.year"
                class="text-base text-gray-900 font-semibold rtl:bg-left"
              >
                <option value="" selected hidden>{{ translations.text.year }}</option>
                <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
              </select>
            </span>
            <span v-show="errors.has('dob_year')" class="font-body text-xs text-orange font-semibold">{{ errors.first('dob_year') }}</span>
          </div> -->
          <Select
            :key="translations.text.year"
            v-model="data.dateofbirth.year"
            name="dob_year"
            :rules="{
              required: true,
              'is-over-18': data.dateofbirth.day + '-' + data.dateofbirth.month + '-' + data.dateofbirth.year,
            }"
            :placeholder="translations.text.year"
            :options="years"
            :label="translations.text.year"
          />
        </div>
        <!-- Month of Birth -->
        <div class="col-span-2 md:col-span-2">
          <!-- <label class="label is-small" for="dob_month">{{ translations.text.month }}<span class="text-orange ml-1">*</span></label>
          <div class="my-2">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('dob_month') }"
                :data-vv-as="translations.text.month"
                name="dob_month"
                v-model="data.dateofbirth.month"
                class="text-base text-gray-900 font-semibold rtl:bg-left"
              >
                <option value="" selected hidden>{{ translations.text.month }}</option>
                <option v-for="(month, index) in translations.months" :value="index" :key="index">{{ month }}</option>
              </select>
            </span>
            <span v-show="errors.has('dob_month')" class="font-body text-xs text-orange font-semibold">{{ errors.first('dob_month') }}</span>
          </div> -->
          <Select
            :key="translations.text.month"
            v-model="data.dateofbirth.month"
            name="dob_month"
            rules="required"
            :placeholder="translations.text.month"
            :options="translations.months"
            :label="translations.text.month"
          />
        </div>
        <!-- Day of Birth -->
        <div class="col-span-2 md:col-span-2">
          <!-- <label class="label is-small" for="dob_day">{{ translations.text.day }}<span class="text-orange ml-1">*</span></label>
          <div class="my-2">
            <span class="select is-fullwidth">
              <select
                v-validate="'required'"
                :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('dob_day') }"
                :data-vv-as="translations.text.day"
                name="dob_day"
                v-model="data.dateofbirth.day"
                class="text-base text-gray-900 font-semibold rtl:bg-left"
              >
                <option value="" selected hidden>{{ translations.text.day }}</option>
                <option v-for="day in daysInMonth" :value="day" :key="day">{{ day }}</option>
              </select>
            </span>
            <span v-show="errors.has('dob_day')" class="font-body text-xs text-orange font-semibold">{{ errors.first('dob_day') }}</span>
          </div> -->

          <Select
            :key="translations.text.day"
            v-model="data.dateofbirth.day"
            name="dob_day"
            rules="required"
            :placeholder="translations.text.day"
            :options="daysInMonth"
            :label="translations.text.day"
          />
        </div>
      </div>
      <!-- Address -->
      <div class="col-span-4 md:col-span-4">
        <label class="font-body text-base text-gray-900  " for="address">{{ translations.text.address }} 1<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <input
            v-validate="'required|min:3|max:255'"
            :class="{ 'input-error': errors.has('dir-address_') }"
            :name="'dir-address_'"
            type="text"
            :data-vv-as="translations.text.address"
            :placeholder="translations.text.address_placeholder"
            v-model="data.address"
          />
          <span v-show="errors.has('dir-address_')" class="font-body text-xs text-orange font-semibold">{{ errors.first('dir-address_') }}</span>
        </div>
      </div>
      <!-- Region -->
      <div class="col-span-4 md:col-span-4" v-if="accountType.toLowerCase() === 'partner'">
        <label class="font-body text-base text-gray-900  " for="address">{{ translations.text.target_geo_location }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <input
            v-validate="'required|alpha_spaces|max:50'"
            :class="{ 'input-error': errors.has('ib_main_target_region') }"
            :name="'ib_main_target_region'"
            type="text"
            :data-vv-as="translations.text.target_geo_location"
            :placeholder="translations.text.target_geo_location"
            v-model="data.ib_main_target_region"
          />
          <span v-show="errors.has('ib_main_target_region')" class="font-body text-xs text-orange font-semibold">{{ errors.first('ib_main_target_region') }}</span>
        </div>
      </div>
      <!-- Address 2 -->
      <div class="col-span-4 md:col-span-4">
        <label class="font-body text-base text-gray-900  " for="address2">{{ translations.text.address2 }}</label>
        <div class="my-2">
          <input
            v-validate="'min:3|max:255'"
            :class="{ 'input-error': errors.has('dir-address2_') }"
            :name="'dir-address2_'"
            type="text"
            :data-vv-as="translations.text.address2"
            :placeholder="translations.text.optional"
            v-model="data.address2"
          />
          <span v-show="errors.has('dir-address2_')" class="font-body text-xs text-orange font-semibold">{{ errors.first('dir-address2_') }}</span>
        </div>
      </div>
      <!-- Town/City, Province/State, Postal/Zip Code -->
      <div class="col-span-4 lg:col-span-4 grid grid-cols-6-default gap-5" v-show="!companyActive">
        <!-- Town/City -->
        <div class="col-span-6 md:col-span-2">
          <label class="font-body text-base text-gray-900  " for="city">{{ translations.text.city }}<span class="text-orange ml-1">*</span></label>
          <p class="my-2">
            <input
              v-validate="'required|min:3|max:255'"
              :class="{ 'input-error': errors.has('city') }"
              name="city"
              type="text"
              :data-vv-as="translations.text.city"
              :placeholder="translations.text.city"
              v-model="data.city"
            />
            <span v-show="errors.has('city')" class="font-body text-xs text-orange font-semibold">{{ errors.first('city') }}</span>
          </p>
        </div>
        <!-- Province/State -->
        <div class="col-span-6 md:col-span-2">
          <label class="font-body text-base text-gray-900  " for="state_province">{{ translations.text.state_province }}</label>
          <p class="my-2">
            <input
              v-validate="'min:3|max:255'"
              :class="{ 'input-error': errors.has('state_province') }"
              name="state_province"
              type="text"
              :data-vv-as="translations.text.state_province"
              :placeholder="translations.text.state_province"
              v-model="data.state_province"
            />
            <span v-show="errors.has('state_province')" class="font-body text-xs text-orange font-semibold">{{ errors.first('state_province') }}</span>
          </p>
        </div>
        <!-- Postal/Zip Code -->
        <div class="col-span-6 md:col-span-2">
          <label class="font-body text-base text-gray-900  " for="post_code">{{ translations.text.post_zip_code }}<span class="text-orange ml-1">*</span></label>
          <p class="my-2">
            <input
              v-validate="'required|max:255'"
              :class="{ 'input-error': errors.has('post_code') }"
              name="post_code"
              type="text"
              :data-vv-as="translations.text.post_code"
              :placeholder="translations.text.post_zip_code"
              v-model="data.post_code"
            />
            <span v-show="errors.has('post_code')" class="font-body text-xs text-orange font-semibold">{{ errors.first('post_code') }}</span>
          </p>
        </div>
      </div>
      <!-- Social media -->
      <div class="col-span-4 md:col-span-2" v-if="accountType.toLowerCase() === 'partner'">
        <label class="font-body text-base text-gray-900  " for="social_media">{{ translations.text.social_media }}</label>
        <p class="my-2">
          <input
            v-validate="'max:255'"
            :class="{ 'input-error': errors.has('social_media') }"
            name="social_media"
            type="text"
            :data-vv-as="translations.text.social_media"
            :placeholder="translations.text.social_media"
            v-model="data.social_media"
          />
          <span v-show="errors.has('social_media')" class="font-body text-xs text-orange font-semibold">{{ errors.first('social_media') }}</span>
        </p>
      </div>
    </div>
    <div class="button-wrapper flex md:justify-start gap-[5%]">
      <Button mode="primary-outlined" customClasses="max-w-[185px]" @click="changePage()">
        {{ $t('previous') }}
      </Button>
      <Button @click="changePage(true)" customClasses="max-w-[185px]">
        {{ upgrade ? $t('submit').tTitle() : $t('continue').tTitle() }}
      </Button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Button from '../reusableComponents/Button.vue'
import Select from '../reusableComponents/Select.vue'

export default {
  components: { Button, Select },
  props: {
    accountType: String,
    activeStep: Number,
    isCompany: Boolean,
    translations: Object,
    formData: Object,
    upgrade: Boolean,
    prefilledTestData: Boolean,
    testData: Object,
  },
  data() {
    return {
      page: this.activeStep,
      years: Array.from({ length: 100 }, (v, i) => moment().year() - i + 1),
      data: {
        gender: '',
        dateofbirth: {
          day: '',
          month: '',
          year: '',
        },
        address: '',
        address2: '',
        ib_main_target_region: '',
        city: '',
        state_province: '',
        post_code: '',
        socialMedia: '',
        numberOfShareholders: 0,
        numberOfDirectors: 0,
      },
    }
  },
  mounted() {
    if (!this.isCompany && this.formData.city) {
      Object.keys(this.formData).forEach(key => {
        if (key === 'dateofbirth' && typeof this.formData[key] === 'string') {
          this.data[key] = {
            day: this.data[key]['day'],
            month: this.data[key]['month'],
            year: this.data[key]['year'],
          }
        } else {
          this.data[key] = this.formData[key]
        }
      })
    }
  },
  created() {
    this.$validator.reset()
    this.errors.clear()
    if (this.formData) {
      Object.keys(this.formData).forEach(key => {
        this.data[key] = this.formData[key]
      })
    } else if (this.prefilledTestData && this.testData) {
      // make a clone object of this.testData in order to prevent it from updates coming from the child component
      const clonedTestData = JSON.parse(JSON.stringify(this.testData))
      Object.keys(clonedTestData).forEach(key => {
        this.data[key] = clonedTestData[key]
      })
    }
  },
  watch: {
    // watcher for the i18n language change
    '$i18n.locale'() {
      this.$validator.reset()
    },
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      BonusConfig: 'bonusconfig/all',
    }),
    companyActive() {
      this.$validator.reset()
      return this.isCompany
    },
    daysInMonth() {
      const year = this.data.dateofbirth.year || new Date().getFullYear()
      const month = this.data.dateofbirth.month || new Date().getMonth() + 1
      return Array.from({ length: new Date(year, month, 0).getDate() }, (_, i) => i + 1)
    },
  },
  methods: {
    changePage(nextStep) {
      if(this.upgrade){
        if (nextStep) {
          if (this.isCompany) {
            this.$bus.$emit('ValidateFinalForm')
          }

          this.$validator.validateAll().then(result => {
            if (result) {
              this.$bus.$emit('DataSubmitted', this.data)
              return this.$bus.$emit('ApiCall')
            }
            // scroll to first message
            let el = document.getElementsByName(this.errors.items[0].field)[0]
            if (el) return el.focus()
          })
        } else return this.$bus.$emit('ChangePage', this.page - 1)
      }
      else{
        if (nextStep) {
          this.validateForm()
        } else return this.$bus.$emit('ChangePage', this.page - 1)
      }
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$bus.$emit('DataSubmitted', this.data)
          this.$bus.$emit('ChangePage', this.page + 1)
          return
        }
        // scroll to first message
        let el = document.getElementsByName(this.errors.items[0].field)[0]
        if (el) return el.focus()
      })
    },
  },
}
</script>
<style scoped></style>
